export const mergeRecords = <K extends keyof any, V>(
  records: Record<K, V>[],
): Record<K, V> => Object.assign({}, ...records);
